import { CONFIRM_DELETE } from '@opengov/stories-shared/constants';
import { RouteComponentProps } from '@reach/router';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react';

import { IModalMessages } from '../../../types';

import { styles } from './RemoveEmbedModal.styles';

export type IRemoveEmbedModalProps = RouteComponentProps & {
  entityId: number;
  messages: IModalMessages;
  isLoading: boolean;
  userId?: number;
  reportTitle?: string;
  onClose(): void;
  deleteReportEmbed(): void;
};

export const RemoveEmbedModal: React.FC<IRemoveEmbedModalProps> = (props) => {
  const { deleteReportEmbed, messages, isLoading, onClose } = props;
  const [inputTextValue, setInputTextValue] = useState('');

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm" data-test="dialog-delete-report-embed" PaperProps={{ sx: styles.dialogPaper }} aria-labelledby="remove-embed-dialog-title">
      <DialogTitle id="remove-embed-dialog-title" sx={styles.dialogTitle}>
        {messages.deleteReport}
        <IconButton aria-label="close" onClick={onClose} size="small" sx={styles.closeButton}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Typography variant="body2">{messages.deleteReportDescription}</Typography>
        <TextField
          size="small"
          fullWidth
          label={messages.deleteConfirmation}
          sx={styles.textField}
          value={inputTextValue}
          onChange={(e) => setInputTextValue(e.target.value)}
          inputProps={{ 'data-test': 'delete-confirmation-input', className: 'no-format' }}
        />
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button variant="outlined" color="secondary" size="small" data-test="cancel-delete-button" onClick={onClose}>
          {messages.cancel}
        </Button>
        <Button
          variant="contained"
          color="error"
          size="small"
          data-test="confirm-delete-button"
          disabled={inputTextValue !== CONFIRM_DELETE || isLoading}
          onClick={deleteReportEmbed}
        >
          {messages.confirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
